module.exports = __webpack_public_path__ + "static/media/Yield Sign.7280a446.png";